module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDI5IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjAwMjA3IDEuOTc1N0wxNC40OTc2IDYuOTg3ODVMMjguMDAyMSAyIiBzdHJva2U9IiNFRTZFNzYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/generic_2/betslip_down_lightred.svg
// module id = 391b
// module chunks = 12